<template>
    <v-btn
            id="botaoCancelar"
            outlined
            depressed
            class="botao-cancelar"
            @click="$emit('cancelar')">
        {{text}}
    </v-btn>
</template>

<script>
export default {
    name: 'BotaoCancelar',
    props: {
        text: {
            type: String,
            default: 'Cancelar'
        }
    }
}
</script>

<style scoped lang="stylus">
    .botao-cancelar
        color #999 !important
</style>
